

































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import UrlWrapper from '@/modules/shared/components/shared/UrlWrapper.vue'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import { ContentImageCollectionModel } from '@/modules/content/models/content-collection.model'
import MarkupTableEmptyRow from '@/modules/common/tes-table/components/shared/MarkupTableEmptyRow.vue'

@Component({
  components: { MarkupTableEmptyRow, SimpleHeader, UrlWrapper, TextEllipsis }
})
export default class ContentImagesTable extends Vue {
  @Prop() images!: ContentImageCollectionModel[]
  @Prop({ default: true }) withHeader !: boolean
  @Prop({ default: 'bg-tes-navy-blue text-tes-white' }) theadClass !: string

  get doesntHaveImage() {
    return !this.images || !this.images.length
  }
}
